
define('text!templates/modals/messenger/message-list.ejs',[],function () { return '<table class="table table-bordered table">\n    <tbody>\n    </tbody>\n</table>';});

